type FetchErrorDetails = {
  url: string;
  status?: number;
  statusText?: string;
  body?: string;
};

export class FetchError extends Error {
  static async fromResponse(res: Response) {
    const { url, status, statusText } = res;
    const body = await res.text();

    return new FetchError('Fetch Error', { url, status, statusText, body });
  }

  static fromUnknownError(e: unknown, url = '') {
    if (e instanceof FetchError) return e;

    const message = e instanceof Error ? e.message : String(e);
    const error = new FetchError(message, { url });
    error.stack = e instanceof Error ? e.stack : '';

    return error;
  }

  static isAuthError(e: unknown) {
    if (!(e instanceof FetchError)) return false;
    return e.status === 401 || e.status === 403;
  }

  url: string;
  status: number;
  statusText: string;
  body: string;

  constructor(message?: string, details?: FetchErrorDetails) {
    super(message);
    this.name = this.constructor.name;
    this.url = details?.url || '';
    this.status = details?.status || 0;
    this.statusText = details?.statusText || '';
    this.body = details?.body || '';
  }
}

// See: https://github.com/sindresorhus/serialize-error/issues/106
Object.defineProperty(FetchError, 'name', { value: 'FetchError' });
